import { gql } from '@apollo/client';

export const QUERY_LIST_DEVICE = gql`
  query listDevice($where: WhereDeviceInput) {
    listDevice(where: $where) {
      list {
        created_at
        last_active_at
      }
    }
  }
`;

export const QUERY_TOTAL_DEVICE = gql`
  query totalDevice($where: WhereDeviceInput) {
    totalDevice(where: $where) {
      total
    }
  }
`;
